module.exports = __webpack_public_path__ + "static/media/history-profile-icon.f303a241.svg";